<template>
  <div class="apply-timeline" v-if="showPage">
      <div class="banner">
        <img src="/static/top-bar.png" alt="" />
      </div>

      <div class="timeline">
        <div class="patient-info">
          <van-image round width="6rem" height="6rem" alt="头像" class="avatar"
            src="/static/user_avatar.jpg"
          />
          <div class="patient-opt">
            <van-button class="download" type="info" size="mini" v-if="showDownload" @click="goDownload" color="#0AA8AF">药品领取单下载<van-icon name="arrow" /></van-button>
            <!-- <van-button @click="showLogout = true" type="info" size="mini" plain color="#0AA8AF">退出登录</van-button> -->
          </div>
          <div class="name-tag">
            <div style="font-size:20px;margin-bottom:8px;">{{name}} &nbsp;{{  substrMobile(mobile) }}</div>
            <van-tag class="info-tag" round color="#DDF1F2" text-color="#0AA8AF" >第{{rounds}}轮次第{{rounds_phase}}周期</van-tag>
            <van-tag class="info-tag" round color="#FFF0DD" text-color="#F1AC53" >{{frontStatus}}</van-tag>
          </div>
          <div class="volunteer-info">
            我的公益专员：
            <template v-if="volunteer">
                {{volunteer.name.substring(0,1)}}专员/{{ substrMobile(volunteer.mobile)}}
            </template>
            <template v-else>暂无</template><br/>
            项目办热线：010-56592455
          </div>
          <div class="clear"></div>
        </div>
        <div class="msg-progress">
          <div class="progress-list">
            <div class="progress-title">申请进度</div>
            <div class="list-cells">
              <div class="list-cell" v-for="(pitem, pindex) in progress" :key="pindex">
                <div class="cell-point">
                  <van-icon v-if="pindex == 0" size="" name="info" color="#0AA8AF" style="background-color: #0AA8AF;box-shadow:0 0 0 3px rgb(28, 180, 157,0.2);margin-left:-6px"/>
                  <div v-else class="point"></div>
                </div>
                <div class="cell-cont" :style="{'color':pitem.created==progress[0].created?'#0AA8AF':'#aaa'}">
                  <div class="cell-title" v-if="pitem.created" >{{splitDate(pitem.created, 'before')}}&nbsp;{{splitDate(pitem.created, 'after')}}</div>
                  <div class="progress-text" >
                    {{pitem.content}}
                  </div>
                  <div v-if="pitem.remark"  class="progress-text">{{pitem.remark}}</div>
                  <div v-if="pitem.username&&pitem.username.indexOf('公益专员')>=0" class="progress-text">当前操作为公益专员{{volunteer && volunteer.name}}操作</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="btn" v-if="showBtn&&loaded">
        <van-button  @click="next()" type="info" round block color="#0AA8AF">{{btnText}}</van-button>
      </div>

      <van-popup class="contract-popup" v-model="showLogout" position="center" :close-on-click-overlay="false">
        <div class="contract-box">
          <!-- <div class="contract-title">{{msg.title}}</div> -->
          <div class="contract-title">
            确认要退出登录吗？
          </div>
          <div class="contract-btn">
            <van-button color="#0AA8AF" round @click="showLogout = false">取消</van-button>
            <van-button color="#0AA8AF" plain round :disabled="submitBtnDisabled" @click="logout()">确认</van-button>
          </div>
        </div>
      </van-popup>

  </div>
</template>

<script>
  import Vue from "vue";
  import {
    Dialog,
    Toast
  } from 'vant';
    import {
    mapState
  } from "vuex";
  import {
    checkin,
    QueryApplyProgress,
    GetPatient,
    checkFace,
    Logout,
    GetReceiveInfo,
    PredictUnlockQuery
  } from '../../api/api'
import { getAgentApply } from '@/api/patient'
  Vue.use(Dialog)
  Vue.use(Toast)

  export default {
    data() {
      return {
        showPage:false,
        showDownload:false,//药品领取单下载按钮
        loaded:false,//数据加载完成
        btnText:"继续申请",
        progress:[{content:"申请中",created:""}],
        name:"",
        mobile:"",
        rounds:"1",
        rounds_phase:"1",
        need_face_ocr:false,
        next_phase:false,
        
        frontStatus:"申请中",
        patient:{},
        phase:{},
        volunteer: null,
        papid:'',
        faceResult:null,//人脸识别结果
        submitBtnDisabled: false,
        showLogout: false, // 退出弹框

        type:'患者申请',//人脸识别类型
        faceResultUnlock:'',//解锁人脸状态
        // unlockRefuse:false,//处方解锁被驳回
        receive_time_unlock:null,//超出计划领药日期
        prescription_unlock:null,//超出处方日期

        inSevenDays:false,//在领药时间7天内

        //判断主页按钮
        is_check:'',//人脸识别
        signature_image:'',//签名

        agentApply:{},//代领人对象

      }
    },
    computed: {
      ...mapState(['patientOne', 'userInfo','patientInfo']),
      showBtn:function () {
        //患者状态判断:可以使用patient,phase, predict, volunteer,faceResult,faceResultUnlock
        
        //患者出组,不显示按钮
        if(this.patient.status=="出组") return false

        //患者申请
        console.log("this.patient",this.patient)
        //提交电子材料之前都是在线申请
        if(!this.patient.status) this.btnText="在线申请"

        if(this.predict){
          //锁定解锁
          //超出处方日期
          console.log("this.prescription_unlock",this.prescription_unlock)
          if(this.prescription_unlock){
            if(this.prescription_unlock.status!="通过"){
                console.log("!this.has_attach,this.unlockStatus=='未通过',this.unlockStatus",!this.has_attach,this.unlockStatus=="未通过",this.unlockStatus)
                if (!this.has_attach&&this.unlockStatus=="未通过") {//没材料
                  this.btnText="上传解锁材料"
                  console.log("超出处方日期-处方锁定")
                  return true
                }else 
                // if(this.unlockStatus=="待上传"){//待上传
                //   this.btnText="上传解锁材料"
                //   console.log("超出处方日期-处方锁定待上传")
                //   return true
                // }else 
                if(this.unlockStatus=="未通过"){//被驳回
                  this.btnText="重新上传解锁材料"
                  console.log("超出处方日期-处方解锁材料被驳回")
                  return true
                }else if(this.unlockStatus=="待审核"){//待审核
                  console.log("超出处方日期-处方解锁材料待审核")
                  return false
                }
            }
          }

          //超出计划领药日期
          if(this.receive_time_unlock){
            if(this.receive_time_unlock.status!="通过"){
              console.log("超出计划领药日期-解锁待审核")
              return false
            }else if(this.receive_time_unlock.status=="通过"){
              //人脸识别
              console.log("faceResultUnlock,this.predict.is_recognition",this.faceResultUnlock,this.predict.is_recognition)
              if((this.faceResultUnlock &&this.faceResultUnlock.status=="审核通过")||this.predict.is_recognition==1){//通过
                console.log("超出计划领药日期-人脸识别通过")
              }else if(!((this.faceResultUnlock &&this.faceResultUnlock.status=="审核通过")||this.predict.is_recognition==1)){//未通过
                if(this.faceResultUnlock.status=="等待审核"){
                  console.log("超出计划领药日期-人脸识别等待审核")
                  return false
                }
                if(this.need_face_ocr){
                  this.btnText="前往人脸识别"
                  console.log("超出计划领药日期-处方解锁后需要人脸识别")
                  return true
                }
              }
            }
          }
        }

        //上传电子材料
        if(this.patient.status == "初始"){
          if(this.patient.statusing == '申请中'){
            //人脸识别状态
            console.log("this.faceResult",this.faceResult)
            if (this.faceResult && this.faceResult.status == '等待审核') {
              console.log("首阶段-患者申请-人脸识别-等待审核")
              return false
            }
            if(this.faceResult && this.faceResult.status == '审核未通过'){
              console.log("首阶段-患者申请-人脸识别未通过")
              this.btnText="前往人脸识别"
              return true
            }
            if(!this.faceResult&&!this.is_check){
              console.log("首阶段-患者申请-前往人脸识别")
              this.btnText="前往人脸识别"
              return true
            }
            //知情同意书状态
            if(!this.signature_image){
              console.log("阅读知情同意书前")
              this.btnText="阅读知情同意书"
              return true
            }
              console.log("电子材料上传前")
              this.btnText="在线申请"
          }
          if(this.patient.statusing == '待初审'&&this.phase.status=="等待审核"){
            //电子材料已提交-待审核
            console.log("首阶段-患者申请-电子材料已提交-待审核")
            return false
          }
          if(this.patient.statusing=="初审驳回"){
            //电子材料被驳回
            console.log("首阶段-患者申请-电子材料被驳回")
            this.btnText="上传材料"
          }
          if(this.patient.statusing=="申请中止"){
            //电子材料-申请中止
            console.log("首阶段-患者申请-申请中止")
            return false
          }
          if(this.patient.statusing=="预约申请通过"){
            //电子材料-预约申请通过
            console.log("首阶段-患者申请-预约申请通过")
            this.btnText="查看邮寄材料"
          }
        }

        //纸质材料
        if(this.patient.status == "未入组"){
          if(this.patient.statusing == '初审通过'&&this.phase.status!="审核通过"){//初审通过,复审没通过
            if(this.phase.status=='申请中止'){
              console.log("首阶段-患者入组-申请中止")
              return false
            }else if(this.phase.status=='预约申请通过'){
              console.log("首阶段-患者入组-预约申请通过")
            }
            console.log("入组审核-纸质邮寄")
            this.btnText="查看邮寄材料"
          }
        }else if(this.patient.status == "在组"){
          // 患者未入组,不会被锁定?

          if (this.patient.receive_phase == 1) {//首阶段
            //文件复核-通过
            if(this.patient.file_review_status=="核对通过"){
              if(this.predict){
                //人脸识别通过前
                if(this.need_face_ocr){//需要人脸识别
                  //人脸识别状态
                  console.log("this.faceResult",this.faceResult)
                  if (this.faceResult && this.faceResult.status == '等待审核') {
                    console.log("首阶段-患者领药-人脸识别-等待审核")
                    return false
                  }
                  console.log("人脸识别未通过",!((this.faceResult &&this.faceResult.status=="审核通过")||this.predict.is_recognition==1))
                  if(!((this.faceResult &&this.faceResult.status=="审核通过")||this.predict.is_recognition==1)){//人脸识别未通过
                    console.log("首阶段-患者领药-人脸识别")
                    this.btnText="前往人脸识别"
                  }
                }else if(!((this.faceResult &&this.faceResult.status=="审核通过")||this.predict.is_recognition==1)){//人脸识别未通过&&未到领药7天前
                  //核对通过-等待排药-到达人脸识别日期之前
                  console.log("首阶段-患者领药-人脸识别-未到人脸识别日期")
                  return false
                }
                //人脸识别通过后
                if((this.faceResult &&this.faceResult.status=="审核通过")||this.predict.is_recognition==1){//通过领药前人脸识别
                  if(this.predict&&!this.next_phase){//有预测单但不能开启下一阶段->还未领药
                    //不在领药前7天内,不显示领药信息
                    if(!this.inSevenDays) return false
                    //领药前7天-人脸识别通过
                    //有代领人-材料提交等待审核
                    if(this.agentApply&&this.agentApply.status=="等待审核"){
                      console.log("代领人材料-等待审核")
                      return false
                    }else if(this.agentApply&&this.agentApply.status=="审核不通过"){
                      console.log("代领人材料-审核不通过")
                      this.btnText="重新上传材料"
                      return true
                    }
                    console.log("首阶段-待领药")
                    this.btnText="查看领药信息"
                  }else if(this.next_phase){//可以开启下一阶段->已经领药
                    console.log("首阶段-可开启下一阶段")
                    this.btnText="开启下一阶段"
                  }
                }
              }else{
                console.log("首阶段-患者领药-等待排药")
                return false
              }
            }else{//文件复核未通过
              if(this.phase.status=="审核通过"){//复审通过
                if(this.patient.file_review_status==""){//没有核对过
                  console.log("首阶段-文件复核-没有核对过",this.patient.file_review_status)
                  this.btnText="上传材料"
                }else if(this.patient.file_review_status=='等待核对'){ //等待核对
                  console.log("首阶段-文件复核-等待核对",this.patient.file_review_status)
                  return false
                }else{//核对不通过
                  console.log("首阶段-文件复核-核对不通过",this.patient.file_review_status)
                  this.btnText="重新上传材料"
                }
              }else{
                console.log("复审状态:",this.phase.status)
                return false
              }
            }
          }
          if (this.patient.receive_phase >= 2) {//后续阶段
            //后续阶段
            // 初审
            if(this.phase.follow_up_status != '后续初审通过'){
              if(this.phase.follow_up_status == ''){
                console.log("后续-初审-未上传")
                this.btnText="上传材料"
              }
              if(this.phase.follow_up_status == '待初审'){
                console.log("后续-初审-等待审核")
                return false
              }
              if(this.phase.follow_up_status == '后续初审驳回'){
                console.log("后续-初审-驳回")
                this.btnText="上传材料"
              }
              // TODO:验证后续初审的逻辑
              if(this.phase.follow_up_status == '预约申请通过'){
                console.log("后续-初审-预约申请通过")
                this.btnText="查看邮寄材料"
              }
              if(this.phase.follow_up_status == '申请中止'){
                console.log("后续-初审-申请中止")
                return false
              }
            }
            
            if(this.phase.follow_up_status == "后续初审通过"){
              //审核文件后复核
              if (this.phase.file_review_status == '核对通过') {
                if(this.predict){
                  if(!((this.faceResult &&this.faceResult.status=="审核通过")||this.predict.is_recognition==1)){//领药前人脸识别通过前
                    if(this.need_face_ocr){
                      //人脸识别状态
                      console.log("this.faceResult",this.faceResult)
                      if (this.faceResult && this.faceResult.status == '等待审核') {
                        console.log("后续-患者领药-人脸识别-等待审核")
                        return false
                      }
                      console.log("后续-患者领药-人脸识别")
                      this.btnText="前往人脸识别"
                    }
                    if(!this.need_face_ocr&&!this.next_phase){
                      console.log("后续-人脸识别前")
                      return false
                    }
                  }else if((this.faceResult &&this.faceResult.status=="审核通过")||this.predict.is_recognition==1){//领药前人脸识别通过后
                    if(this.predict&&!this.next_phase){//有预测单但不能开启下一阶段->还未领药
                      //不在领药前7天内,不显示领药信息
                      if(!this.inSevenDays) return false
                      //领药前7天-人脸识别通过
                      //有代领人-材料提交等待审核
                      if(this.agentApply&&this.agentApply.status=="等待审核"){
                        console.log("代领人材料-等待审核")
                        return false
                      }else if(this.agentApply&&this.agentApply.status=="审核不通过"){
                        console.log("代领人材料-审核不通过")
                        this.btnText="重新上传材料"
                        return true
                      }
                      console.log("后续-待领药")
                      this.btnText="查看领药信息"
                    }
                    if(this.next_phase){//可以开启下一阶段->已经领药
                      console.log("后续-可开启下一阶段")
                      this.btnText="开启下一阶段"
                    }
                    // if(!this.need_face_ocr&&!this.next_phase){
                    //   //人脸识别后,领药前
                    //   console.log("后续-人脸识别后,领药和开启下一阶段前")
                    //   return false
                    // }
                  }
                }else{
                  console.log("后续-患者领药-等待排药")
                  return false
                }
              } else {//审核文件后复核没通过
                if(this.phase.status=="审核通过"){//复审通过
                  if (this.phase.file_review_status == '') {
                    console.log("后续-文件复核-没有核对过",this.patient.file_review_status)
                    this.btnText="上传材料"
                  } else if (this.phase.file_review_status == '等待核对') {
                    console.log("后续-文件复核-等待核对",this.patient.file_review_status)
                    return false
                  }else{
                    console.log("后续文件复核-核对不通过",this.patient.file_review_status)
                    this.btnText="重新上传材料"
                  }
                  //复审没通过
                }else if(this.phase.status!="审核通过"){
                  if(this.phase.status=="预约申请通过"){
                    console.log("后续-复审-预约申请通过")
                  }
                  if(this.phase.status=="申请中止"){
                    console.log("后续-复审-申请中止")
                    return false
                  }
                  console.log("后续-复审未通过-继续邮寄")
                  this.btnText="查看邮寄材料"
                }
              }
            }
          }
        }
        return true
      },
    },
    async created() {
      let now=new Date();
      this.progress[0].created=this.getTime(now)
      this.mobile=this.userInfo.mobile;//默认使用微信手机号
      await this.checkLogin()
      this.name=this.userInfo.nickname;//默认使用微信昵称
      await this.search();
      this.loaded=true;
      this.showPage=true;
    },
    methods: {
      substrMobile(mobile) {
        if (!mobile) return  ''
        let regular=/(\d{3})\d*(\d{4})/
        return (mobile+'').replace(regular,'$1****$2');
      },
      getTime(time) {
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        return year + '-' + month + '-' + day;
      },

      async checkLogin(){
        //检查是否是登陆用户
        await checkin()
          .then(res => {
            console.log("checkin", res);
              //将获取到的数据存入vuex
            if (!res.data) {
              console.log("没有登陆")
              this.$router.replace({ name: "Login" });
              return
            }else{
              this.name=res.data.name
              if(res.data.mobile) this.mobile=res.data.mobile
              this.is_check=res.data.is_check
              this.signature_image=res.data.signature_image
              this.$store.commit("setPatientOne", { patientOne: res.data });
              let userInfo = this.$store.getters.getUserInfo;
              userInfo.patient = res.data
              this.papid=res.data.papid
              this.$store.commit("setUserInfo", userInfo);
            }
          }).catch(err => {
            console.log("timeline-checkin出错")
            Toast(err.response.data.message);
            this.$router.replace({
              name: "Login"
            });
            return
          });
      },
      splitDate(date, local) {
        let arr = date.trim().split(/\s+/)
        if (local == 'before') {
          return arr[0]
        }
        if (local == 'after') {
          return arr[1]
        }
      },
      async search() {
        const self = this;
        console.log("this.patientOne",this.patientOne)
        if(!this.papid) {//患者没有papid,显示默认信息
          console.log("没有papid")

          return
        }
        this.submitBtnDisabled = true
        await QueryApplyProgress({
           papid: this.papid
          }).then((res) => {
            // Toast('查询成功')
            self.submitBtnDisabled = false

            //去掉部分日志信息
            self.progress=[]
            let temp=[]
            let temp1=['新增阶段领药信息','阶段领药完成']
            let temp2=['工作人员开始处理您的申请']
            // console.log(res.data.progress)
            res.data.progress.forEach(ele => {
              // if(!temp2.includes(ele.content)  && !temp2.includes(ele.content)  )
              if(temp1.some(key=>{ return ele.content.indexOf(key)>=0})) return
              if(temp2.some(key=>{ return ele.remark.indexOf(key)>=0})) return
              temp.push(ele)
            })
            self.progress=this.Unrepeated(temp)

            self.papid = res.data.phase.patient_id
            self.showSearch = false
            self.showProgress = true
          })
          .catch((err) => {
            self.submitBtnDisabled = false
            console.log("QueryApplyProgress-",err.response.data.message)
            // Toast(err.response.data.message)
          });
        let res = await GetPatient({
          papid: this.papid
        })
        const {
          patient,
          phase,
          predict,
          volunteer,
          need_face_ocr,
          next_phase,
          prescription_unlock,
          receive_time_unlock
        } = res.data;
        this.$store.commit("setPatientInfo",res.data );
        
        this.patient = patient
        this.phase = phase
        this.predict = predict
        this.volunteer = volunteer
        this.rounds= phase.rounds

        this.name=this.patientOne.name
        this.rounds_phase=res.data.rounds_phase
        this.frontStatus= res.data.frontStatus
        this.need_face_ocr=need_face_ocr
        this.next_phase=next_phase
        this.prescription_unlock=prescription_unlock
        this.receive_time_unlock=receive_time_unlock
        // console.log(this.phase.file_review_status, 'this.phase.file_review_status')
        if(patient.total_received_times>0) this.showDownload=true

        if(predict){
          let pre_receive_date=new Date(predict.pre_receive_date.replace(/-/g,"/"))
          let now=new Date()
          const SEVENDAYS=604800000
          console.log("pre_receive_date.getTime()",pre_receive_date.getTime())
          console.log("now.getTime()",now.getTime())
          console.log("pre_receive_date.getTime()-now.getTime()",pre_receive_date.getTime()-now.getTime())
          console.log("SEVENDAYS",SEVENDAYS)
          if(pre_receive_date.getTime()-now.getTime()<SEVENDAYS) this.inSevenDays=true;
        }
        // 
        // if (this.predict) {
        //   if (this.predict.id) {
        //     this.showcode = true
        //   }
        // }
        // 
        let sendData={type:'患者申请'}
        if(predict) sendData={ type: '患者领药',predict_id:predict.id}
        await checkFace(sendData).then(res => {
          if (res.data) {
            this.faceResult = res.data.face
          }
        })
        if(predict&&predict.show_agent_apply){
          await getAgentApply({papid: this.papid}).then(res => {
            if (res.data) {
              this.agentApply = res.data
              console.log("代领人对象",this.agentApply)
            }
          })
        }
        if(receive_time_unlock||prescription_unlock){
          await checkFace({ type: '预测单解锁',predict_id:predict.id}).then(res => {
            if (res.data) {
              this.faceResultUnlock = res.data.face
            }
          })
          await PredictUnlockQuery({papid: this.papid}).then(res => {
            if(res.data.checkItem){
              this.has_attach=res.data.has_attach
              this.unlockStatus=res.data.status
              // if(res.data.checkItem.every(ele=>{return ele.status=="待上传"})) this.unlockStatus="待上传"
            }
          })
        }

        

        // let receiveInfo = await GetReceiveInfo({papid: this.papid})
        // console.log(receiveInfo.data)
      },
      Unrepeated(rawData){
        let timeArr=[] //记录日志的创建时间
        let needDelete=[] //需要删除的元素序号
        let outData=[]
        let temp=rawData
        for (let i in rawData){
          if(timeArr.length==0){
            timeArr.push(rawData[i].created)
          }else if(timeArr.indexOf(rawData[i].created)>=0){
            needDelete.push(i)
          }else{
            timeArr.push(rawData[i].created)
          }
        }
        needDelete.forEach(index=>{temp.splice(index,1,'已删除')})
        if(temp) outData=temp.filter(ele=>{return ele!='已删除'})

        console.log("输入:",rawData)
        console.log("时间记录:",timeArr)
        console.log("需要删除的元素序号:",needDelete)
        console.log("输出:",outData)

        return outData
      },
      next(){
        this.$router.push({name:'Blank'})
      },
      goDownload(){
        this.$router.push({name:'applyDownload'})
      },
      logout() {
        const that = this
        this.submitBtnDisabled = true
        Logout().then((res)=>{
          that.showLogout = false
          that.$router.replace({
            name: "Login"
          });
        }).catch(err => {
          console.log("Logout出错")
          Toast(err.response.data.message);
          that.submitBtnDisabled = false
        });
      },
    }

  }
</script>

<style lang="less">
  .apply-timeline {
    min-height:100vh;
    .banner{
      position:absolute;
      top: 0;
      width: 100%;
      height: 100px;
      background-color: #13AFB6;
      z-index: -9;
      img{
        width:100%;
        height: 100px;
      }
    }
    .patient-info{
      margin: 40px 0 0 0;
      width: 100%;
      min-height: 120px;
      background-color: white;
      border-radius: 6px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      position: relative;
      overflow:initial;
      .avatar{
        margin: -3rem 0 0 3rem;
      }

      .info-tag {
        font-size: 14px; margin-right: 5px; padding: 0 9px; line-height: 1.5;
      }
      .patient-opt {
        position: absolute; top: 5px; right: 5px; left: 10rem; text-align: right;display: flex;justify-content:flex-end;align-items:center;
        .download{
          background-color:#13AFB6;
          text-align: right;
          border-radius: 2px;
          color: white;
          display: flex;
          justify-content:center;
          align-items:center;
          box-shadow: 0 0 4px #0AA8AF;
        }
        .van-button {
          margin: 0 4px;
          &.van-button--mini {
            height: 22px; padding: 0 8px;
          }
        }
      }
      .name-tag{
        margin: 0 2rem 1rem 2rem;
      }
      .volunteer-info {
        margin: 0 2rem 2rem 2rem;
        color: #787878; font-size: 14px; margin-bottom: 1.8rem;
      }
    }



    // background: #fff;
    .msg-bd-wait {
      box-sizing: border-box;
      margin: 32px 16%;
      border-radius: 10px;
      padding: 20px;
      box-shadow: 0px 1px 10px 0px rgba(0, 101, 155, 0.2);
      overflow: hidden;
      background-color: #fff;

      .title {
        margin-bottom: 0;
        color: #444;

        .van-icon {
          font-size: 24px;
          vertical-align: -5px;
          margin-right: 10px;
          color: @yellow;
        }
      }
    }

    .msg-ft {
      margin: 30px 20%;

      &>* {
        margin-bottom: 20px;
      }
    }

    .msg-tips {
      color: #999;
      text-align: center;
      margin: 10px 5% 10px;
      padding: 5px;
    }

    .msg-progress {
      margin: 20px 12% 100px  0 !important;
      .progress-list{
        .progress-title{
          padding-top:0;
        }
        .list-cells {
          .list-cell {
            .cell-cont {
              color: #aaa;
            }
            &:first-child {
              .cell-cont {
                color: @main-green;
              }
            }
          }
        }
      }
    }

    .timeline {
      padding: 16px 3% 0 3%;

      .van-cell-group__title {
        padding: 10px;
        background: @theme-color;
        color: #fff;
      }
    }

    // .next-phase {
    //   margin: 16px 3%;

    //   .van-cell-group__title {
    //     padding: 10px;
    //     background: @theme-color;
    //     color: #fff;
    //   }
    // }


    button.van-button.van-button--info.van-button--normal.van-button--block.van-button--round {
      box-shadow: 0 0 3px #0AA8AF;
    }
    .btn{
      // background-color: rgb(245,246,254);
      background-color: rgb(255, 255, 255);
      position: fixed;
      bottom: 0;
      padding:  15px 15px 25px 15px;
    }
    .cell-point{
      .van-icon{
        top:0;
      }
    }
    .cell-cont{
      padding: 0 0 20px 0;
      .cell-title{
        font-size: 12px !important;
        padding-bottom: 5px;
      }
      .progress-text{
        font-size: 15px;
      }
    }

    .contract-box {
      position: relative;
      display: flex;
      flex-direction: column;
      // padding-bottom: 40px;
      background: #fff;
      min-width: 300px;
      .contract-title {
        background: #fff;
        box-sizing: content-box;
        width: auto;
        line-height: 24px;
        height: 24px;
        font-size: 1.6rem;
        text-align: center;
        padding: 40px 50px 10px;
        background: #fff;
      }

      .contract-text {
        flex: 1;
        height: 50%;
        font-size: 1.4rem;
        text-align: center;
        line-height: 1.5;
        height: 100%;
        padding: 15px;
        overflow-y: auto;
        transition: transform .3s;
        -webkit-overflow-scrolling: touch;
      }

      .contract-btn {
        background: #fff;
        text-align: center;
        padding: 30px 15px;
        // position: absolute;
        // left: 50%;
        // bottom: 0;
        // margin-left: -50px;
        .van-button {
          width: 100px; margin: 0 10px;
        }
      }
    }
    .contract-popup{
      border-radius: 8px;
    }
    
  }
</style>